module.exports = __webpack_public_path__ + "img/dots-menu.e946ef09.svg";